import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { Environment } from './environments/environment';

import * as Sentry from '@sentry/browser';

if (Environment.production) {
  enableProdMode();
}


const serverErrorsRegex = new RegExp(
  `401 Unauthorized|403 Forbidden|404 Not Found|502 Bad Gateway|503 Service Unavailable`, 'mi'
);

if (Environment.sentryEnable) {
  Sentry.init({
    dsn: 'https://7e5ffc180115468aa29f78f652bbdc41@sentry.io/2448627',
    ignoreErrors: [
      'Non-Error exception captured',
      serverErrorsRegex
    ]
  });
}

(function () {
  function getChromeVersion() {
    const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    return raw ? parseInt(raw[2], 10) : false;
  }

  const chromeVersion = getChromeVersion();
  if (chromeVersion && chromeVersion >= 80) {
    Array.prototype.reduce = function (callback /*, initialValue*/) {
      'use strict';
      if (this == null) {
        throw new TypeError('Array.prototype.reduce called on null or undefined');
      }
      if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
      }
      // eslint-disable-next-line no-bitwise
      const t = Object(this), len = t.length >>> 0;
      let value: any, k = 0;
      if (arguments.length === 2) {
        value = arguments[1];
      } else {
        while (k < len && !(k in t)) {
          k++;
        }
        if (k >= len) {
          throw new TypeError('Reduce of empty array with no initial value');
        }
        value = t[k++];
      }
      for (; k < len; k++) {
        if (k in t) {
          value = callback(value, t[k], k, t);
        }
      }
      return value;
    };
  }
})();

(function() {

  window.addEventListener('resize', resizeMainView);

  function resizeMainView() {

    const height = window.innerHeight;

    const mainView = document.getElementById('main-view');

    if (mainView) {
      mainView.style.height = height.toString() + 'px';
    }
  }

  document.onreadystatechange = function() {
    if (document.readyState === 'complete') {
      resizeMainView();
    }
  };

})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
